module.exports = __webpack_public_path__ + "media/images/views/dashboard/calendar-cd569a9b4a1f0dc7474ffef25f99f7d6.png";